import { t } from '../helpers/i18n';
import { gs } from '../helpers/settings';
import GeewenLogo from './GeewenLogo';

/**
 * GeewenNav.jsx —— 官网顶栏 (首页与产品详情页共用)
 *
 * ⚠️ locale 是纯文本, 不能塞图标 ⇒ 图标在渲染处补 (Flarum 的 Icon 组件)。
 *
 * @param {object} props
 * @param {string} props.anchorBase 站内锚点前缀
 *   - 首页传 '' ⇒ '#gs-products' (页内滚动)
 *   - 详情页传 '/geewen' ⇒ '/geewen#gs-products' (回首页再定位)
 */
export default class GeewenNav {
  view(_ref) {
    let {
      anchorBase = ''
    } = _ref;
    const navItems = [{
      href: anchorBase + '#gs-products',
      key: 'nav.products'
    }, {
      href: anchorBase + '#gs-platform',
      key: 'nav.platform'
    }, {
      href: anchorBase + '#gs-roadmap',
      key: 'nav.roadmap'
    }, {
      href: anchorBase + '#gs-about',
      key: 'nav.about'
    }].map(item => m("li", {
      class: "GS-nav-item",
      key: item.key
    }, m("a", {
      href: item.href
    }, t(item.key))));
    return m("header", {
      class: "GS-nav"
    }, m("div", {
      class: "GS-container GS-nav-inner"
    }, m("a", {
      class: "GS-brand",
      href: "/geewen"
    }, m(GeewenLogo, null), m("span", {
      class: "GS-brand-text"
    }, m("span", {
      class: "GS-brand-name"
    }, gs('geewen_brand_name', t('meta.brand_name'))), m("span", {
      class: "GS-brand-by"
    }, gs('geewen_brand_by', t('meta.brand_by'))))), m("nav", {
      class: "GS-nav-links"
    }, m("ul", null, navItems)), m("div", {
      class: "GS-nav-actions"
    }, m("a", {
      class: "GS-btn GS-btn--ghost",
      href: anchorBase + '#gs-cta'
    }, t('nav.contact')), m("a", {
      class: "GS-btn GS-btn--primary",
      href: "/"
    }, t('nav.forum')))));
  }
}
flarum.reg.add('ziiven-geewen-site', 'forum/components/GeewenNav', GeewenNav);